import React, { useEffect, useState } from 'react'

// third party libarry
import { Breadcrumb, Card, Row, Col, Form, Modal, Spinner, Button } from "react-bootstrap"
import useReactRouter from "use-react-router";
import { useToasts } from "react-toast-notifications";
import Switch from "react-switch";
import { useLazyQuery, useMutation } from '@apollo/client';

//components
import bill_true from "../../../image/bills_true.png"
import bill_false from "../../../image/bills_false.png"
import bill_is_logictcs from "../../../image/bill_logistics.png"
import bill_is_logictcs_v2 from "../../../image/bill_logictics_v2.png"
import { COLOR_APP, COLOR_TEXT, COLOR_WHITE } from '../../../constants';
import { GET_SHOPS, SHOP } from '../../../graphql/shop/queryShop';
import { UPDATE_SHOP } from '../../../graphql/shop/mutation';
import HorizontalRule from '../../../constants/HorizontalRule';
import LoadingSpinner from '../../../components/LoadingSpinner';
import LoadingUpdates from '../../../components/LoadingUpdates';

// icons
import { FaCheckCircle } from 'react-icons/fa';
import { RiArrowLeftRightLine } from 'react-icons/ri';
import _ from 'lodash';


export default function SettingBills() {

    // hook use state
    const { history } = useReactRouter();
    const [isLastStock, setIsLastStock] = useState(false);
    const shopId = localStorage.getItem("SHOP")
    const { addToast } = useToasts();
    const [loadingEdit, setLoadingEdit] = useState(false);
    const [exampleBill, setExampleBill] = useState()


    // useMutation
    const [updateShop, { loading: loadingUpdate }] = useMutation(UPDATE_SHOP);

    // useLazyQuery to fetch the initial state
    const [loadShop, { data: shopData}] = useLazyQuery(SHOP, { fetchPolicy: "cache-and-network" });

    // useEffect 
    useEffect(() => {
        if (shopId) {
            fetchShopData(shopId)
        }
    }, [shopId]);

    useEffect(() => {
        if (shopData) {
            setExampleBill(shopData?.shop?.exampleBill);
        }
    }, [shopData]);
 

    // function to update the shop and refresh local state
    const _updateShop = async (typeBill) => {
        const shopId = localStorage.getItem("SHOP");
        try {
            if (loadingUpdate) return;
            setLoadingEdit(true)
            let _data = {}

            if (!_.isEmpty(typeBill)) {
                _data = {
                    ..._data,
                    exampleBill: typeBill
                }
            }
            const res = await updateShop({
                variables: {
                    where: { id: shopId },
                    data: _data
                }
            });
            if (res) {
                fetchShopData(shopId)
                setLoadingEdit(false)

            }
        } catch (err) {
            console.error(err);
        }
    };

    // query shop data 
    const fetchShopData = async (_shopId) => {
        await loadShop({
            variables: {
                where: {
                    id: _shopId,
                },
            },
        });
    }
 

    // select bills to update shop
    const onSelectBills = (type) => {
        _updateShop(type)
    }


    // if (loadingShop) return <Card style={{ height: '70vh', background: COLOR_WHITE, padding: 10, boxShadow: 'none' }}>
    //     <LoadingSpinner />
    // </Card>

    return (
        <>
            <Breadcrumb>
                <Breadcrumb.Item onClick={() => history.replace("/settings")}>
                    ຕັ້ງຄ່າ
                </Breadcrumb.Item>
                <Breadcrumb.Item active>ບິນອໍເດີ້</Breadcrumb.Item>
            </Breadcrumb>

            <Card style={{ background: COLOR_WHITE, padding: 10, boxShadow: 'none' }}>
                <h5 style={{ fontWeight: 'bold' }}>ເລືອກແບບບິນທີ່ທ່ານຕ້ອງການ</h5>
                <br />

                <div className='card-main-bill'>

                    {exampleBills.map((item, index) => (
                        <div className='card-example-bill' style={{ border: exampleBill === item?.type ? `4px solid ${COLOR_TEXT}` : '1px solid #ddd' }} key={index}>
                            <img src={item?.image} />
                            <Button variant={exampleBill === item?.type ? 'success' : 'outline-success'} className='btn-select-card' onClick={() => onSelectBills(item?.type)}>ເລືອກນຳໃຊ້ແບບທີ່ {index + 1} {index + 1 === 3 && "(ຕົວໜັງສືເຂັ້ມ)"}</Button>
                        </div>
                    ))}


                </div>
 
            </Card>

            <HorizontalRule />



            {/* loading update shop */}
            <LoadingUpdates loading={loadingUpdate} title="ກຳລັງອັບເດດ..." openLoading={loadingEdit} />
        </>
    )
}


const exampleBills = [
    {
        title: "ບິນແບບບໍ່ສະແດງລາຄາສິນຄ້າ",
        type: "NOT_ISPRICE",
        image: bill_false
    },
    {
        title: "ແບບສະແດງລາຄາສິນຄ້າ",
        type: "ISPRICE",
        image: bill_true
    },
    {
        title: "ແບບສະແດງລາຄາສິນຄ້າ ຕົວໜັງສືໜາ",
        type: "ISPRICE_BOLD",
        image: bill_true
    },
    {
        title: "ແບບໃຊ້ຂົນສົ່ງ",
        type: "IS_LOGICTICS",
        image: bill_is_logictcs
    },
    {
        title: "ແບບໃຊ້ຂົນສົ່ງ",
        type: "BILL_LOGICTICS_V2",
        image: bill_is_logictcs_v2
    },
    // {
    //     title: "(ສຳຫລັບ) ບິນຂະໜາດນ້ອຍ",
    //     type: "LABEL_BILL",
    //     image: ""
    // },
]
